module.exports = __webpack_public_path__ + "static/19-86d9f48303a718e323445e6086245d5c.jpg";